export const ROUTES = {
  home: "/",
  checking: "/checking",
};
